<template>
  <v-container class="ClassSelection class-list py-5">
    <header class="class-list-title">
      <h1 class="mb-8">Assigned classes</h1>
      <sch-search
        :input-value.sync="search"
      ></sch-search>
    </header>
    <div class="class-list-filters">
      <sch-filter-option
        :input-val.sync="name"
        :options="classNameOptions"
        title="Name"
        @select="filter"
      ></sch-filter-option>
      <sch-filter-option
        :input-val.sync="location"
        :options="locations"
        title="Location"
        @select="filter"
      ></sch-filter-option>
      <sch-filter-option
        :input-val.sync="grade"
        :options="gradeOptions"
        title="Grade"
        @select="filter"
      ></sch-filter-option>
      <sch-filter-option
        :input-val.sync="timeframe"
        :options="timeframes"
        title="Timeframe"
        @select="filter"
      ></sch-filter-option>
    </div>

    <div class="class-list-items">
      <SchoolClassCard
        v-for="cls in classes"
        :key="cls._id"
        :name="cls.name"
        :subject="cls.subject"
        :timeframe="cls.timeframe"
        :grade="cls.grade"
        :location="cls.location"
        :students-count="cls.students.length"
        @select="selectClass(cls)"
      />
    </div>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

// TODO add attendance info for classes

export default {
  name: 'ClassSelection',
  components: {
    SchSearch: () => import('@/components/form-inputs/SchSearch'),
    SchFilterOption: () => import('@/components/form-inputs/SchFilterOption'),
    SchoolClassCard: () => import('@/components/classes/SchoolClassCard'),
  },
  data() {
    return {
      search: '',
      name: '',
      location: '',
      grade: '',
      timeframe: '',
    };
  },
  computed: {
    ...mapGetters({
      getFilteredClasses: 'classes/getFilteredClasses',
    }),
    classNameOptions() {
      return this.classes.map(entity => ({ value: entity.name, name: entity.name }));
    },
    locations() {
      return this.classes.map(entity => ({ value: entity.location, name: entity.location }));
    },
    gradeOptions() {
      return this.classes.map(entity => ({ value: entity.grade, name: entity.grade }));
    },
    timeframes() {
      return this.classes.map(entity => ({ value: entity.timeframe, name: entity.timeframe }));
    },
    classes() {
      return this.getFilteredClasses({
        search: this.search,
        grade: this.grade,
        name: this.name,
        location: this.location,
        timeframe: this.timeframe,
      });
    },
  },
  created() {
    this.loadSchoolClasses();
  },
  methods: {
    ...mapActions({
      addChildren: 'children/addChildren',
      loadSchoolClasses: 'classes/loadSchoolClasses',
    }),
    selectClass(cls) {
      this.addChildren(cls.students);
      // TODO go to assignments filtered by class id
    },
    filter() {

    },
  },
};
</script>

<style scoped lang="scss">
.class-list {
  font-family: "Montserrat";

  &-title {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &-filters {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
    margin: 28px auto 36px;
  }

  &-items {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .sch-class {
      margin: 8px;
    }
  }
}
</style>
